import { BorderRadius, Color, getDefaultTransition, getShadow, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface IntentTileWrapperProps {
  hasError: boolean
  isSelected: boolean
}

const intentTileWrapperSelectedStyle = css`
  border-color: ${Color.Black};
`

const intentTileWrapperErrorStyle = css`
  border-color: ${Color.Red700};
`

export const IntentTileWrapper = styled.button<IntentTileWrapperProps>`
  display: flex;
  flex-direction: column;
  padding: ${Spacing.S8};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  ${getShadow('raisedLight')};
  cursor: pointer;
  ${getDefaultTransition('border-color')};

  &:hover {
    border-color: ${Color.Black};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${({ hasError }) => hasError && intentTileWrapperErrorStyle};
  ${({ isSelected }) => isSelected && intentTileWrapperSelectedStyle};
`

export const IntentTileTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding-right: ${Spacing.S8};
  padding-left: ${Spacing.S8};
`

export const IntentTileItemWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: ${Spacing.S8};
`

interface SelectionIndicatorProps {
  isSelected: boolean
}

const selectionIndicatorSelectedStyle = css`
  border-color: ${Color.Black};
  background-color: ${Color.Black};
`

export const SelectionIndicator = styled.div<SelectionIndicatorProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 2px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R4};
  background-color: ${Color.White};
  ${getDefaultTransition('border-color', 'background-color')};

  ${({ isSelected }) => isSelected && selectionIndicatorSelectedStyle};
`

const checkIconWrapperSelectedStyle = css`
  opacity: 1;
`

export const CheckIconWrapper = styled.div<SelectionIndicatorProps>`
  display: flex;
  opacity: 0;
  ${getDefaultTransition('opacity')};

  ${({ isSelected }) => isSelected && checkIconWrapperSelectedStyle};
`
